<template lang="pug">
v-card(v-if="allUserFlows", color="#f7f9fC")
  v-card-text
    transition(name="fade", mode="out-in")
      .text-center(v-if="loading")
        v-progress-circular(indeterminate, size="64")
      v-card(v-else, flat, color="#f8f9fC")
        .d-flex.mb-4
          v-spacer
          v-btn.mr-2(text, @click="closeAll")
            | close all
          v-btn(color="primary", @click="expandAll")
            | expand all
        v-expansion-panels(v-model="panel", multiple, flat, focusable)
          FlowEditWrapper(
            v-for="(category, i) in categories",
            :key="i",
            :title="category",
            :expert="expert"
          )
            template(v-slot="{ isEdit }")
              v-row(
                v-for="(question, j) in getQuestionsByCategory(category)",
                :key="j"
              ) 
                v-col(cols="6")
                  span(v-text="question.title")
                v-col(v-if="!isEdit", cols="6") 
                  div(
                    v-for="(answer_block, k) in question.answer_blocks",
                    :key="k",
                    v-html="getParsedValue(answer_block.alias_result)"
                  )
                v-col(v-else, cols="6") 
                  div(
                    v-for="(answer_block, k) in question.answer_blocks",
                    :key="k"
                  ) 
                    span(
                      v-if="!isEdit",
                      v-html="getParsedValue(answer_block.alias_result)"
                    )
                    EditAnswerBlock(
                      v-else,
                      :data="answer_block",
                      :questionID="question.ID",
                      :userflowID="question.userflow_id",
                      :stepID="question.step_id"
                      @refresh="getParsedFlows"
                    )
</template>

<script>
import FlowEditWrapper from "./FlowEditWrapper";
import EditAnswerBlock from "./EditAnswerBlock";
import { GetParsedFlowsURL } from "@/utils/apiUrls";

export default {
  name: "flow_editor",

  components: {
    FlowEditWrapper,
    EditAnswerBlock,
  },

  props: {
    showNotPassed: {
      type: Boolean,
      default: false,
    },

    flows: {
      type: Array,
      default: () => [],
    },

    expert: {
      type: Boolean,
      default: false,
    },

    flowAliases: {
      type: Array,
      required: false,
      default: () => [
        "case_free",
        "case_paid",
        "case_paid_key",
        "case_paid_officer",
        "case_paid_cos",
        "case_paid_lvl1",
      ],
    },

    caseID: {
      type: [String, Number],
    },
  },

  data: () => ({
    parsedFlows: [],
    loading: false,
    panel: [],
  }),

  watch: {
    flowAliases: {
      immediate: true,
      handler: "getParsedFlows",
    },
  },

  computed: {
    allUserFlows() {
      if (this.expert) return this.flows;
      if (this.showNotPassed) return this.$store.state.flows.list;
      return this.$store.state.flows.list.filter(
        ({ status }) => status == "passed"
      );
    },

    questions() {
      let questions = [];
      if (!this.parsedFlows) return [];
      let sortedFlows = this.parsedFlows;
      // console.log(sortedFlows);
      try {
        sortedFlows.sort((a, b) => {
          var indexA = this.flowAliases.indexOf(a.alias);
          var indexB = this.flowAliases.indexOf(b.alias);
          if (indexA < indexB) {
            return -1;
          } else if (indexA > indexB) {
            return 1;
          } else {
            return 0;
          }
        });
      } catch (e) {
        console.log(e);
      }
      try {
        sortedFlows.forEach((f) => {
          if (f.steps) {
            f.steps.forEach((s) => {
              if (s.condition_result) {
                s.question.answer_blocks = s.question.answer_blocks.map(
                  (ab) => {
                    ab.skip_step = s.skip_step;
                    return ab;
                  }
                );
                s.question.step_id = s.ID
                s.question.userflow_id = f.userflow_id
                questions.push(s.question);
              }
            });
          }
        });
      } catch (e) {
        console.log(e);
      }

      return questions;
    },

    categories() {
      let categories = new Set();
      // console.log(this.questions.map((q) => q.category));
      this.questions.forEach((q) => categories.add(q.category));
      // console.log(categories);
      let sortedCategories = [];

      Array.from(categories).forEach((c) => {
        // @TODO IMHO its a crutch, we must got ordering from backend

        // Core
        if (c === "Company details") sortedCategories[0] = c;
        else if (c === "Address") sortedCategories[1] = c;
        // Case Profile
        else if (c === "Profile") sortedCategories[10] = c;
        else if (
          c === "Previously submitted applications and sponsorship duties"
        )
          sortedCategories[11] = c;
        else if (c === "Authorising officer") sortedCategories[12] = c;
        else if (c === "Key contact") sortedCategories[13] = c;
        else if (c === "Level 1 User") sortedCategories[14] = c;
        else if (c === "Employment of migrants") sortedCategories[15] = c;
        else if (c === "Certificate of sponsorship (CoS)")
          sortedCategories[16] = c;
        else if (c === "Sponsor licence registration") sortedCategories[17] = c;
        else if (c === "UK immigration details") sortedCategories[18] = c;
        // Etc
        else if (c === "Other") sortedCategories[99] = c;
        else sortedCategories[Number(sortedCategories.length) + 1] = c;
      });

      return sortedCategories.filter((c) => c != null);
    },

    currentUserFlows() {
      return this.allUserFlows.filter((uf) =>
        this.flowAliases.includes(uf.flow.alias)
      );
    },
  },

  methods: {
    getParsedValue(text) {
      switch (text) {
        case "false":
          return "No";
        case "true":
          return "Yes";
        default:
          return text;
      }
    },

    getQuestionsByCategory(category) {
      if (category === "Key contact")
        return this.questions.filter(
          (q) => q.category === "Key Contact" || q.category === "Key contact"
        );
      let questions = this.questions.filter((q) => q.category == category);
      return questions;
    },

    closeAll() {
      this.panel = [];
    },

    expandAll() {
      this.panel = Array.from(Array(this.categories.length).keys());
    },

    getParsedFlows() {
      let params = {
        flow_ids: this.currentUserFlows.map(({ ID }) => ID) + "",
      };
      if (this.caseID) {
        params.case_id = this.caseID;
      }
      this.loading = true;
      this.axios
        .get(GetParsedFlowsURL, { params })
        .then(({ data }) => {
          if (Array.isArray(data)) {
            this.parsedFlows = data.map(({ flow, ID }) => {
              flow.userflow_id = ID
              return flow
            });
          }
          this.loading = false;
        })
        .catch(console.error);
    },
  },
};
</script>
